// extracted by mini-css-extract-plugin
export default {"actions_container":"admin_actions_container__5Qib2","icon":"admin_icon__GFVET"};